<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/census-vacant-beds'"
    />    
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'VacantBedDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `vacant_dates/${this.$route.params.id}`,
            lite_rest_api:      `vacant_dates`,
            rest_api_note:      `vacant_date_notes`,
            form_format:        FormResources.form_format_edition,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.vacant_date;
            this.array_options = {
                bed_vacant_id:  data.bed_codes
            }
            this.title_page     = this.single_object.date;
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.date,
                href:   '#',
                arrow:  " ",
            });
        },

    },

    watch: {
        async 'single_object.building_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    level_request:  true,
                }
                const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(http_request)}`);
                if(response.status) {
                    this.array_options.level_id = response.data.levels;
                } else {
                    this.error_handling(response)
                }
            }
        }
    },

    async mounted(){
        await this.api_request(this.rest_api);
    }
}
</script>